import React from "react";
import { useNavigate } from "react-router-dom";
import heroImg from "../../../Assets/ServicesPage_Assets/HeroImg_Ninja.png";

const ServicePageHero = ({ page_data }) => {
  const navigate = useNavigate();

  // Pick correct register path from page_data
  const handleRegister = () => {
    if (page_data?.registerPath) {
      navigate(page_data?.registerPath || "/RegisterCourse", {
        state: { courseName: page_data?.title || "Default Course" },
      });
    } else {
      navigate("/RegisterCourse", { state: page_data }); // fallback
    }
  };

  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1>
          From novice to Ninja:
          <br />
          Unleash your coding <br /> prowess
        </h1>
        <p>
          With our accelerated{" "}
          <strong>{page_data?.title || "Web Development"}</strong> bootcamp.
        </p>
        <button className="btn-start" onClick={handleRegister}>
          Start Learning Today
        </button>
      </div>
      <div className="hero-img">
        <img
          src={page_data?.heroImg || heroImg}
          alt={page_data?.title || "Ninja"}
        />
      </div>
    </section>
  );
};

export default ServicePageHero;
